"use client";

import type { SchedulingDuration } from "@repo/api";
import { SelectField } from "@repo/ui/form-fields";
import { useFieldBinding } from "@/shared/forms/connected-fields";

export const OPTIONAL_DURATION_OPTIONS: { label: string; value: number; unit: "min" | "h" }[] = [
  { label: "5 minutes", value: 5, unit: "min" },
  { label: "10 minutes", value: 10, unit: "min" },
  { label: "15 minutes", value: 15, unit: "min" },
  { label: "20 minutes", value: 20, unit: "min" },
  { label: "25 minutes", value: 25, unit: "min" },
  { label: "30 minutes", value: 30, unit: "min" },
];

export const NONE_VALUE = "__none__";

function encode(d: SchedulingDuration): string {
  return `${d.value}-${d.unit}`;
}

function decode(key: string): SchedulingDuration | null {
  if (key === NONE_VALUE) return null;
  const [val, unit] = key.split("-");
  return { value: Number(val), unit: unit as "min" | "h" };
}

export interface OptionalDurationFieldProps {
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function OptionalDurationField({ label, description, disabled }: OptionalDurationFieldProps) {
  const { value, onChange, onBlur, errors, isTouched } = useFieldBinding<SchedulingDuration | null>();

  return (
    <SelectField
      value={value ? encode(value) : NONE_VALUE}
      onChange={(v) => {
        if (v) onChange(decode(v));
        onBlur();
      }}
      onBlur={onBlur}
      errors={errors}
      isTouched={isTouched}
      label={label}
      description={description}
      options={[
        { value: NONE_VALUE, label: "None" },
        ...OPTIONAL_DURATION_OPTIONS.map((o) => ({ value: encode(o), label: o.label })),
      ]}
      disabled={disabled}
    />
  );
}
